import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions'; // 👈 nueva importación

// ==================================================
// CONFIGURACIÓN FIREBASE
// ==================================================
export const firebaseConfig = {
  apiKey: 'AIzaSyCNWWi-RfOQKqT5cL9ykG8zbOC3j0JzJ6I',
  authDomain: 'ekineapp.firebaseapp.com',
  projectId: 'ekineapp',
  storageBucket: 'ekineapp.firebasestorage.app',
  messagingSenderId: '224228806013',
  appId: '1:224228806013:web:4dc23310c9a8bd4e795014',
};

// ==================================================
// INICIALIZACIÓN
// ==================================================
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ==================================================
// SERVICIOS FIREBASE
// ==================================================
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1"); // 👈 NUEVA LÍNEA

// ==================================================
// EXPORTAR APP
// ==================================================
export { app };
